import { Skeleton } from "@/components/ui/skeleton";
import type { ReactElement } from "react";

const ROW_GRID = "grid grid-cols-[minmax(0,1fr)_11rem_5.5rem] items-center gap-5";

export function DefaultPriceAdjustmentSkeleton(): ReactElement {
  return (
    <div className="flex justify-between gap-4">
      <Skeleton className="h-5 w-48 self-center" />
      <div className="flex items-center gap-2">
        <Skeleton className="h-9 w-40" />
        <Skeleton className="h-9 w-9 rounded-md" />
      </div>
    </div>
  );
}

export function PriceAdjustmentsListSkeleton(): ReactElement {
  return (
    <div className="space-y-1.5">
      <Skeleton className="h-4 w-52" />

      <div className={ROW_GRID}>
        <Skeleton className="h-3 w-12" />
        <Skeleton className="ml-auto h-3 w-24" />
        <div />
      </div>

      {Array.from({ length: 2 }, (_, i) => (
        <div key={i} className={`${ROW_GRID} py-0.5`}>
          <Skeleton className="h-5 w-32" />
          <Skeleton className="ml-auto h-5 w-16" />
          <div className="flex justify-end gap-2">
            <Skeleton className="h-9 w-9 rounded-md" />
            <Skeleton className="h-9 w-9 rounded-md" />
          </div>
        </div>
      ))}

      <div className={`${ROW_GRID} py-0.5`}>
        <Skeleton className="h-9" />
        <Skeleton className="h-9" />
        <div className="flex justify-end">
          <Skeleton className="h-9 w-9 rounded-md" />
        </div>
      </div>
    </div>
  );
}
